/* global google, zubie_driver, car_marker, ajax_vars */

export default {
  init: function () {

    let map;
    const mapPlaceholder = document.getElementById("map");
    let driver;
    const loader = document.getElementById('map-loader');
    const driverDetails = document.getElementById('driver-details');
    const driverDetailsName = driverDetails.querySelector('.driver-name');
    const data = {
      action: 'get_driver_data_zubie',
      security: ajax_vars.ajax_nonce,
      driver: zubie_driver,
    }
    let timeLeft = 60; // Timer in seconds to send ajax request
    let timeTotal = timeLeft;
    const progressBar = document.getElementById("update-progress-bar");
    let getDriverDataCounter = 0;
    const getDriverDataFireCount = timeLeft;
    let confirmCount = 0;
    const confirmCountFire = timeLeft * 20; // 20 minutes we ask for confirmation

    const getData = (callback) => {
      jQuery.get(ajax_vars.ajax_url, data, 'JSON')
        .done((response) => {

          callback(response);
        })
        .fail((xhr, status, error) => {
          // eslint-disable-next-line no-console
          console.log(error);
          somethingWentWrongMessage();
        });
    }

    getData((response) => {

      if ( ! response.success ) {
        somethingWentWrongMessage();
        hideLoader();
        return;
      }

      driverDetails.style.display = 'block';
      driverDetailsName.innerHTML = response.data.name;

      hideLoader();

      const center = new google.maps.LatLng(response.data.location.lat, response.data.location.lon);

      map = new google.maps.Map(mapPlaceholder, {
        center: center,
        zoom: 17,
      });

      const icon = {
        url: car_marker,
        scaledSize: new window.google.maps.Size(55, 55),
        anchor: { x: 20, y: 20 },
      }

      driver = new google.maps.Marker({
        position: new google.maps.LatLng(center),
        map: map,
        icon: icon,
      });

      if (response.data.heading) {
        setTimeout(() => rotateDriverMarker(response.data.heading), 500);
      }

      const timerInterval = setInterval(() => {

        // Ask for confirmaton if the user haven't left the page open and left. We want to avoid pinging the api
        if (confirmCount >= confirmCountFire) {
          if (! confirm('Are you still tracking the driver? Press ok to continue.')) {
            clearInterval(timerInterval);
            reloadThePageMessage();
            return;
          }

          confirmCount = 0;
        }

        if(timeLeft <= 0){
          timeLeft = timeTotal;
        }

        progressBar.value = timeLeft;

        // Update driver location every minute
        if (getDriverDataCounter === getDriverDataFireCount) {
          getDriverDataCounter = 0;

          getData((response) => {

            // If we get error while updating the car location
            if ( ! response.success ) {
              clearInterval(timerInterval);
              somethingWentWrongMessage();
              return;
            }

            const center = new google.maps.LatLng(response.data.location.lat, response.data.location.lon);

            // just move the marker around.
            driver.setPosition(center);

            if (response.data.heading) {
              rotateDriverMarker(response.data.heading);
            }

            map.panTo(center);

          })
        }

        confirmCount++;
        getDriverDataCounter++;
        timeLeft--;

      }, 1000);
    });

    const rotateDriverMarker = (heading) => {
      const marker = document.querySelector(`[src="${car_marker}"]`);
      if ( marker ) { // when it hasn't loaded, it's null
        const actualAngle = heading - 90;
        marker.style.transform = `rotate(${actualAngle}deg)`;
      }
    };

    const hideLoader = () => {
      loader.style.display = 'none';
    }

    const somethingWentWrongMessage = () => {
      mapPlaceholder.parentElement.innerHTML = '<h2>Something wen\'t wrong.</h2>';
    }

    const reloadThePageMessage = () => {
      mapPlaceholder.parentElement.innerHTML = '<h2>Please reload the page to see the map again.</h2>';
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/zubie-driver-tracking.js